import { Contract } from "./contract";
import { ContractSlice } from "./contract-slice";

export class ContractSliceDetail {
    id?: string;
    index?: number;
    contractSlice?: ContractSlice;
    contractSlices?: ContractSlice[];
    contract?: Contract | null;
    isCreationMode?: boolean;
    isEditMode?: boolean;
    isReadOnlyMode?: boolean;
    constructor(contractSliceDetail?: ContractSliceDetail) {
        this.id = contractSliceDetail?.id;
        this.index = contractSliceDetail?.index;
        this.contractSlice = contractSliceDetail?.contractSlice;
        this.contract = contractSliceDetail?.contract;
        this.isCreationMode = contractSliceDetail?.isCreationMode;
        this.isEditMode = contractSliceDetail?.isEditMode;
        this.isReadOnlyMode = contractSliceDetail?.isReadOnlyMode;
    }
}
